var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caring-nodata"},[_c('i',{staticClass:"iconfont icon-wushuju"}),_vm._t("message",function(){return [_c('div',[_vm._v("暂无相关数据")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }